// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1eRkU","row":"ProcedureTreatmentSummary_row__TZAbQ"};